import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import NewSettingAPI from "src/api/new-interfaces/live/setting";
import { mapErrorCode } from "src/helpers/api";
import { useState } from "src/hooks/state";
import { useUserInfo } from "src/hooks/user";

const INITIAL_STATE = {
  apiErrors: [],
  isLoading: true,
  showModalActivation: false,
  depositAutoWithdrawalResponse: {}
};

function useDepositAutoWithdrawalBanner() {
  let isMounted = true;
  const { t } = useTranslation(["errors"]);
  const { user } = useUserInfo();
  const [state, setState] = useState(INITIAL_STATE);

  async function getDepositWithdrawal() {
    try {
      const response = await NewSettingAPI.getDepositAutoWithdrawal();
      if (isMounted) {
        setState({ depositAutoWithdrawalResponse: response, isLoading: false });
      }
    } catch (errors) {
      const formattedErrors = mapErrorCode(t, errors);
      if (isMounted) {
        setState({
          apiErrors: formattedErrors
        });
      }
    }
  }

  useEffect(() => {
    if (!!Object.keys(user).length) {
      getDepositWithdrawal();
    }
  }, [user]);

  useEffect(() => {
    () => {
      isMounted = false;
    };
  }, []);

  return {
    state,
    methods: { setState }
  };
}

export default useDepositAutoWithdrawalBanner;
